/**
 * Batch 17 R2 (GRF-41): Create from a sprint board puts the new item in that board's active sprint. The header's Create
 * link and the `c` shortcut add `sprint=active` when the person is looking at a project's board in sprint mode
 * (`/p/:key/board` with the project's sprints on) or the fixed active-sprint view (`/p/:key/sprint`). The backlog, the
 * Kanban views and every other page do not add it: there "no sprint" is the expected outcome, or there are no sprints.
 */
export const SPRINT_ORIGIN_PARAM = "sprint";
export const SPRINT_ORIGIN_ACTIVE = "active";

export function isSprintBoardPath(pathname: string, projectKey: string, sprintsOn: boolean, projectSprintsEnabled: boolean | undefined): boolean {
  if (!sprintsOn || !projectKey) return false;
  const base = `/p/${encodeURIComponent(projectKey)}`;
  const path = pathname.replace(/\/+$/, "");
  if (path === `${base}/sprint`) return true;
  // The unified board is in sprint mode when the project runs sprints (BoardPage's rule). Not known yet (the project list
  // is still loading): no mark, rather than a maintenance-mode board briefly marked as a sprint board.
  return path === `${base}/board` && projectSprintsEnabled === true;
}

/** The Create link for the project, marked as started from its sprint board when it was. */
export function createHrefFor(projectKey: string, fromSprintBoard: boolean): string {
  if (!projectKey) return "/items/new";
  const base = `/items/new?project=${encodeURIComponent(projectKey)}`;
  return fromSprintBoard ? `${base}&${SPRINT_ORIGIN_PARAM}=${SPRINT_ORIGIN_ACTIVE}` : base;
}
